window.$$translations = {
    'I want to keep my number': 'אני רוצה לשמור על המספר שלי',
    'Choose a number': 'בוחרים מספר',
    'Continue': 'לְהַמשִׁיך',
    'I want a new number': 'אני רוצה מספר חדש',
    'Enter a mobile number': 'הקלידו מספר נייד',
    'You can return to any stage at any time': 'ניתן לחזור לכל שלב בכל עת',
    'Fill in details': 'ממלאים פרטים',
    'SIM selection and delivery': 'בחירת סים ומשלוח',
    'Confirm Order': 'מאשרים הזמנה',
    'Payment': 'משלמים',
    'Click Here': 'לחצו כאן',
    'A valid phone number must be entered': 'יש להזין מספר טלפון חוקי',
    'Type desired number': 'הקלד את המספר הרצוי',
    'Or choose one of the following numbers': 'או בחרו אחד מהמספרים הבאים',
    'Availability check': 'בדיקת זמינות',
    'Accept': 'אישור',
    'Cancel': 'ביטול',
    'Delete': 'מחיקה',
    'Edit': 'עריכה',
    'Want to add another line?': 'רוצים להוסיף קו נוסף?',
    'For your attention, the details you filled in on this page will be used by WE to establish the subscription and to correspond officially with the subscriber in accordance with all laws'
        : 'לתשומת לבך, הפרטים שמילאת בדף זה ישמשו את WE להקמת המנוי ולהתכתבות רשמית עם המנוי בהתאם לכל החוקים',
    'Private Client': 'לקוח פרטי',
    'Business Client': 'לקוח עסקי',
    'The main points of the program': 'עיקרי התוכנית',
    'Details of the subscriber': 'פרטי בעל המנוי',
    'Subscriber address': 'כתובת המנוי',
    'Company address': 'כתובת החברה',
    'Enter the company address': 'הזנת כתובת החברה',
    'Settlement': 'יישוב',
    'Street / P.O.': 'רחוב / ת.ד.',
    'Apartment': 'דירה',
    'Floor': 'קומה',
    'Entrance': 'כניסה',
    'A valid Israeli number must be entered': 'יש להזין מספר ישראלי חוקי',
    'First name': 'שם פרטי',
    'At least two characters must be entered. letters, dashes and dash (\') only': 'יש להזין לפחות שני תווים. אותיות, מקפים ומקף (\') בלבד',
    'Last Name': 'שם משפחה',
    'ID': 'תעודת זהות',
    'Email': 'דוא”ל',
    'A valid Israeli ID number must be entered, including a check digit': 'יש להזין מספר תעודת זהות ישראלי תקף, כולל ספרת ביקורת',
    'Contact Phone Number': 'טלפון ליצירת קשר',
    'A valid Israeli number must be entered': 'יש להזין מספר ישראלי חוקי',
    'H.P. number': 'מספר ח”פ',
    'Company Name': 'שם החברה',
    'Company Details': 'פרטי החברה',
    'Website': 'אתר אינטרנט',
    'Israel Post': 'דואר ישראל',
    'Summary of selected numbers': 'סיכום מספרים נבחרים',
    'Choose the SIM type of this number': 'בחר את סוג ה-SIM של מספר זה',
    'I am interested in a SIM card': 'אני מעוניין בכרטיס SIM',
    'I have a Ping SIM': 'יש לי Ping SIM',
    'I want an eSIM': 'אני רוצה eSIM',
    'Before connecting to the service, you must make sure that your device supports it in eSIM technology. After the purchase is completed, follow up The instructions will be sent to your email':
    'לפני התחברות לשירות עליך לוודא כי מכשירך תומ בטכנולוגית eSIM. לאחר סיום הרכישה יש לעקוב אחר ההוראות שישלחו לתיבת המייל שלך',
    'Note': 'שים לב',
    'Send me the SIM card to another address': 'שלח לי את כרטיס ה-SIM לכתובת אחרת',
    '(400 minutes) Call Out - associate number to package': '( 400 דקות ) Call Out - שיוך מספר לחבילה',
    'Number': 'מספר',
    'Primary Number': 'מספר ראשוני',
    'For your attention, if you port your existing subscription, connecting the line and starting to use the cellular package will be done, only after receiving the SIM, replacing the SIM in your device and successfully completing the porting process.'
    : 'לתשומת ליבך, במידה וניידת את המנוי שברשותך, חיבור הקו והתחלת שימוש בחבילה הסלולר יבוצע, רק לאחר קבלת ה-SIM, ביצוע החלפת ה-SIM במכשירך והשלמת תהליך הניוד בהצלחה.',
    "If you joined using eSIM technology, after completing the purchase you must follow the instructions that will be sent to the email box. The service will be activated after downloading the profile and disconnecting the line. All subscriptions under this order will be associated with Expon 018, unless the customer has requested otherwise. Dialing to HOL must be done using the prefix 018 and the charges will appear on the mobile subscriber's invoice. As long as you don't dial abroad, you won't be charged for the 018 service."
    : 'אם הצטרפתם באמצעות טכנולוגיית eSIM, לאחר השלמת הרכישה עליכם לפעול לפי ההוראות שיישלחו לתיבת המייל. השירות יופעל לאחר הורדת הפרופיל וניתוק הקו. כל המנויים לפי הזמנה זו ישויכו לאקספון 018, אלא אם הלקוח ביקש אחרת. את החיוג ל-HOL יש לבצע באמצעות הקידומת 018 והחיובים יופיעו בחשבונית המנוי הסלולרי. כל עוד לא תחייגו לחו"ל, לא תחויב עבור שירות 018.',
    'Subscription details': 'פרטי המנוי',
    'Delivery details': 'פרטי משלוח',
    'I approve the main plans, regulations and general terms': 'אני מאשר את התכניות העיקריות, התקנות והתנאים הכלליים',
    'I approve all lines in my possession of services': 'אני מאשר את כל הקווים שברשותי השירותים',
    'I approve receiving marketing messages from PING and its business partners by any means': 'אני מאשר קבלת הודעות שיווקיות מ-PING ומשותפיה העסקיים בכל דרך שהיא',
    'My Order': 'ההזמנה שלי',
    'Shipping fees, connection fees, SIM card cost - one time': 'דמי משלוח, דמי חיבור, עלות כרטיס סים – חד פעמי',
    'How to receive the invoice': 'אופן קבלת החשבונית',
    'An international operator': 'מפעיל בינלאומי',
    'Cellphone': 'טלפון נייד',
    'Expon': 'אקספון',
    'Cellcom': 'סלקום',
    'Rami Levy': 'רמי לוי',
    'Hot Mobile': 'הוט מובייל',
    'Golan Telecom': 'גולן טלקום',
    'Select a number': 'בוחרים מספר',
    'Offer me another number': 'הצע לי מספר אחר',
    'Select this number': 'בחר מספר זה',
    'The number you requested is available':'המספר שביקשת פנוי',
    'Your number has been successfully selected!':'מספרך נבחר בהצלחה!',
    'Line': 'קו ',
    '!Currently there are not available plans': '!כרגע אין תוכניות זמינות',
    'I am interested in a SIM card':'אני מעוניין/ת בכרטיס סים',
    'I want eSIM':'אני רוצה eSIM',
    'I have an XPhone SIM card': 'יש לי סים של XPhone',
    '* Select the SIM type for this number':'בחרו בסוג הסים של מספר זה *',
    'Shipping method': 'שיטת המשלוח ',
    'Israel Post (0.00 NIS) - up to 7 business days': 'דואר ישראל (0.00 ש"ח) - עד 7 ימי עסקים',
    'Home delivery (19.90 NIS) - up to 3 business days': 'שליח עד הבית (19.90 ש"ח) - עד 2 ימי עסקים',
    'For Payment': 'לתשלום',
    'Subscription address': 'כתובת המנוי',
    'Shipping Address': 'כתובת משלוח',
    'Pay Attention!': 'שימו לב!',
    'You have chosen to delete this number': 'בחרתם למחוק את קו מספר',
    'No problem at all, just note that at least one line must beleft to continue the process': 'אין בעיה כלל, רק שימו לב שיש להישאר עם קו אחד לפחות בכדי להמשיך את התהליך,',
    'Before connecting to the service, please make sure that your device supports eSIM technology': 'לפני התחברות לשירות עליכם לוודא כי מכשירכם תומך בטכנולוגיית eSIM',
    'If your device appears here, it supports this technology': 'במידה ומכשירכם מופיע כאן, הוא תומך בטכנולוגיה זו:',
    'By clicking on "Confirm", you confirm that you have checked if your device indeed supports eSIM technology and that you can continue with the purchasing process': 'בלחיצה על “אישור”, הנכם מאשרים שבדקתם האם שמכשירכםאכן תומך בטכנולוגיית eSIM וכי ניתן להמשיך בתהליך הרכישה',
    'Wait... we already know each other':'רגע… אנחנו כבר מכירים',
    'The ID number is already recognized in the system, the numbers you selected will be added as an additional subscription to your account': 'מספר תעודת הזהות כבר מוכר במערכת, המספרים שבחרת יצורפו כמנוי נוסף לחשבונך',
    'Click here to send it again':'לחצו כאן',
    'Didn\'t receive a code?':'לא קיבלתם קוד? לשליחת קוד פעם נוספת',
    'A verification code will now be sent via SMS. Enter the 4 digits you received here':'כעת נשלח למספר-הודעת SMS קוד אימות.',
    'Your ESIM can now be activated.': 'כעת ניתן להפעיל את ה ESIM שלכם',
    'Clear subscription to playback': 'בחר מנוי להפעלה',
    'New line subscription': 'מנוי קו חדש',
    'Skip Step': 'דלג שלב',
    'Run through eSIM activation.': 'הפעלה דרך עמוד הפעלת eSIM',
    'The QR number is ready, now scan the code': 'המספר מוכן, כעת סרקו את קוד ה-QR',
    'Please note that this code is linked': 'שימו לב שקוד זה מקושר',
    'only to the number' :'אך ורק למספר',
    'instructions': 'ההוראות',
    'Before scanning the barcode, it is recommended to read.': 'טרם סריקת הברקוד, מומלץ לקרוא את',
    'To install an eSIM, depending on the type of your device': 'להתקנת eSIM, בהתאם לסוג מכשירכם',
    'If code cannot be scanned - QR manial activation': 'הפעלה ידנית - במידה ולא ניתן לסרוק קוד QR',
    'iOS Users': 'משתמשי iOS',
    'Go to device settings > Cellular > Add eSIM (cellular terminal)': 'נכנסים להגדרות מכשיר > סלולרי > הוסף eSIM (תוחנית סלולרית)',
    'Copy the activation code you received and enter it into two fields': 'יש להעתיק את קוד ההפעלה שקיבלת ולהזין לשני שדות',
    'copying': 'העתקה',
    'Address + DP-SM:': 'כתובת + DP-SM:',
    'Activation Code:': 'Activation Code:',
    'Android Users': 'משתמשי Android',
    'Go to Device settings > Connections > SIM card manager > Add mobile plan Copy the activation code you received into the activation code field': 'נכנסים להגדרות מכשיר > חיבורים > מנהל כרטיסי סים > הוסף תוכנית סלולרית יש להעתיק את קוד ההפעלה שקיבלת לשדה קוד ההפעלה',
    'Device type and Operatimg System - eSIM Installation': 'התקנת eSIM - סוג המכשיר ומערכת ההפעלה',
    'Before activating eSIM, you must enter the device settings and follow': 'לפני הפעלת eSIM, יש להיכנס להגדרות המכשיר ולעקוב אחרי',
    'The instructions, depending on the operating system of the device': 'ההנחיות, בהתאם למערכת ההפעלה של המכשיר',
    'eSIM Activation': 'הפעלת eSIM',
    'Android Operation system': 'במערכת הפעלה Android',
    'In device settings, go to Cellular.': 'בהגדרות המכשיר, יש להיכנס ל“סלולרי”,ולבחור ב-”הוסף תכנית סלולרית”',
    'Click Add Mobile plan button and scan the QR code.': 'יש לסרוק את קוד ה-QR, ולאשר בכפתור “הוסף תכנית סלולרית”',
    'In the device settings, go to "Cellular", and choose "Add cellular plan"': 'בהגדרות המכשיר, יש להיכנס ל“סלולרי”,ולבחור ב-”הוסף תכנית סלולרית”',
    'Scan the QR code, and confirm with the "Add cellular plan" button': 'יש לסרוק את קוד ה-QR ולאשר בכפתור הרלוונטי',
    'In the device settings, go to "Connections" > "SIM card manager" > "Add mobile package", then select "Scan service provider\'s QR code"': 'בהגדרות המכשיר, יש להיכנס ל“חיבורים” > “מנהל כרטיסי SIM” > “הוסף חבילה סלולרית”, ואז לבחור ב”סריקת קוד QR של ספק השירות”',
    'Scan the QR code and confirm with the relevant button': 'יש לסרוק את קוד ה-QR ולאשר בכפתור הרלוונטי',
    'IOS Operation system': 'במערכת הפעלה IOS',
    'In the following screens, the mode must be defined': 'במסכים הבאים, יש להגדיר את אופן השימוש בקו עד לסיום התהליך:',
    'label for cellular plans': 'תווית עבור תכניות סלולריות',
    'Default line for issuing calls from the contact list on the device': 'קו ברירת מחדל להוצאת שיחות מרשימת אנשי הקשר שבמכשיר',
    'Setting up a line for use with IMESSAGE u-FACETIME': 'הגדרת קו לשימוש עם IMESSAGE u-FACETIME',
    'Setting a default line to use cellular data': 'הגדרת קו ברירת מחדל לשימוש בנתונים סלולריים',
    'Close': 'סגור',
    'The SIM card was successfully activated and processed.': 'כרטיס הסים הופעל בהצלחה ותהליך הניוד החל!',
    'The mobilization process is scheduled to end Thursday at 1 pm - 2:15 pm': 'תהליך הניוד עתיד להסתיים ביום ה’ בשעה 2:15',
    'When there is no reception on your device,': 'כאשר אין קליטה במכשירך,',
    'The XPhone SIM card must be inserted into the device, and restarted': 'יש להכניס את כרטיס הסים של XPhone למכשיר, ולהפעילו מחדש',
    'Still struggling? Use our guides': 'עדיין מתקשים? היעזרו במדריכים שלנו',
    'Android Guide': 'למדריך Android',
    'IOS Guide': 'למדריך IOS',
    'Click to activate another SIM': 'להפעלת סים נוסף',
    'For your attention, the move will be made within 40 minutes on Sunday-Thursday, between the hours of 08:00-21:00, and on Friday between the hours of 08:00-12:00. Mobility requests received outside business hours will be processed the next business day starting at 08:00 am': 'לתשומת ליבכם, הניוד יבוצע תוך 40 דקות בימים א’-ה’, בין השעות 08:00-21:00, וביום ו’ בין השעות 08:00-12:00. בקשות ניוד שיתקבלו מחוץ לשעות הפעילות יטופלו ביום העסקים הבא החל מ-08:00 בבוקר',
    'Keep in mind that there are situations in which the mobility process may fail!': 'קחו בחשבון כי קיימים מצבים בהם תהליך הניוד עשוי להיכשל!',
    'Attention - your number': 'שימו לב - מספרכם',
    'is about to be blocked!': 'עומד להיות מנויד!',
    'Porting a phone number allows you to switch from one mobile phone company to another without the need to change the phone number you are used to. The goal of the mobility process is to create competition in the market by moving easily and quickly between the cellular companies.': 'ניוד מספר טלפון מאפשר מעבר מחברת סלולר אחת לאחרת ללא צורך בשינוי מספר הטלפון אליו התרגלתם. מטרת תהליך הניוד היא ליצור תחרות בשוק על ידי מעבר נוח ומהיר בין חברות הסלולר.',
    'In order to enable the roaming procedure, we must make sure that this number is indeed associated with you, now we will send you a 4-digit verification code via SMS.': 'בכדי לאפשר את הליך הניוד, עלינו לוודא שמספר זה אכן משויך אליכם, כעת נשלח אליך בהודעת SMS קוד אימות בן 4 ספרות.',
    'In order to enable the roaming procedure, we must make sure that this number is indeed associated with you,': 'בכדי לאפשר את הליך הניוד, עלינו לוודא שמספר זה אכן משויך אליכם,',
    'We will now send you a 4-digit verification code via SMS.': 'כעת נשלח אליך בהודעת SMS קוד אימות בן 4 ספרות.',
    'The 4 sofas you received must be entered here': 'יש להזין כאן את 4 הספרות שקיבלת',
    'return': 'חזרה',
    'Congratulations, ': 'מזל טוב ',
    'The service and order were carried out successfully!': ' השירות וההזמנה בוצעו בהצלחה!',
    'Order Number: ': 'מספר הזמנה: ',
    'So what happens now?': 'אז מה קורה עכשיו?',
    'Lines with an ESIM card:': 'קווים בעלי כרטיס ESIM:',
    'Your ESIM cards can be activated': 'ניתן להפעיל את ה ESIM שלכם דרך האתר',
    'Lines with a physical SIM Cards:': 'קווים בעלי כרטיס סים פיזי:',
    'You can activate them when they reach you ': 'ניתן להפעילם כשיגיעו אליכם ',
    'Back to Home page': 'לדף הבית',
    'The SIM arrived by delivery': 'הגעת הסים במשלוח',
    'up to 7 business days': 'עד 7 ימי עסקים',
    'Get the sim and activate': 'מקבלים את הסים ומפעילים',
    'Follow the instructions attached to the shipment, and in any case our call center is here for you': 'עקבו אחר ההוראות שנצרף למשלוח, ובכל מקרה המוקד שלנו כאן בשבילכם',
    'Connect to XPhone': 'מתחברים ל-XPhone',
    'And that\'s it, you\'re connected!': 'וזהו, אתם מחוברים!',
    'Continue activating ESIM': 'המשך להפעלת ESIM',
    'Numbers:': 'הקווים:',
    'You have selected physical SIM card, so they can be activated when they arrive. ': 'הם בעלי כרטיס סים פיזי, ועל כן ניתן להפעילם כשיגיעו אליכם ',
    'The SIM arrived by delivery': 'הגעת הסים במשלוח',
    'Clear subscription to activate.': 'בחר מנוי להפעלה',
    'Your eSIM has been activated successfully!': 'ה-eSIM שלכם הופעל בהצלחה!',
    'Please note': 'שים לב',
    'line': 'קו',
    'is currently unavailable': 'לא נינת להפעלה כרגע',
    'The national mobility system operates on Sunday-Thursday at 08:00-21:00 and on Friday and holiday evening at 08:00-13:30. You can return during business hours and perform the process.': 'מערכת הניוד הארצית פועלת בימים א’-ה’ בשעות 08:00-21:00 וביום ו’ וערב חג בשעות 08:00-13:30. באפשרותך לחזור במסגרת שעות הפעילות ולבצע את התהליך.',
    'Select a different subscription to activate': 'בחר מנוי אחר להפעלה',
    'Continue to the main page': 'המשך לדף הראשי',
    'This is a mandatory field': 'זהו שדה חובה',
    'By Address': 'לפי כתובת',
    'according to P.O.': 'לפי ת.ד.',
    'Continued': 'המשך',
    'Home address is identical to shipping address': 'כתובת מגורים זהה לכתובת למשלוח',
    'P.O.': 'ת.ד.',
    'for package details': 'לפרטי החבילה',
    'line number': 'מספר קו',
    'Please note that the PING call center operates on Sunday-Thursday, between the hours of 08:00 and 21:00, and on Friday between the hours of 08:00 and 12:00. Requests received outside business hours will be processed the next business day starting at 08:00 am': 'לתשומת ליבך, מוקד PING פועל בימים א’-ה’, בין השעות 08:00-21:00, וביום ו’ בין השעות 08:00-12:00. בקשות שיתקבלו מחוץ לשעות הפעילות יטופלו ביום העסקים הבא החל מ-08:00 בבוקר',
    'The SIM card has been successfully activated and the roaming process has begun!': 'כרטיס הסים הופעל בהצלחה ותהליך הניוד החל!',
    'The mobility process will begin on Thursday at 2:00': 'תהליך הניוד יחל ביום ה’ בשעה 2:00',
    'at': 'בשעה',
    'The mobility process is about to end': 'תהליך הניוד עתיד להסתיים',
    'on': 'ביום',
    'The mobility process will begin on the day': 'תהליך הניוד יחל ביום',
    'The mobility process is about to end On Thursday at 2:15': 'תהליך הניוד עתיד להסתיים ביום ה’ בשעה 2:15',
    'When there is no reception on your device, The XPhone SIM card must be inserted to the device, and restart it': 'כאשר אין קליטה במכשירך, יש להכניס את כרטיס הסים של XPhone למכשיר, ולהפעילו מחדש',
    'Activate your new SIM!': 'הפעילו את הסים החדש שלכם!',
    'Choose the type of SIM you have': 'בחרו את סוג הסים שברשותכם',
    'A text with an explanation of this part, to be determined by the company and adjusted accordingly afterwards': 'מלל עם הסבר על חלק זה, שייקבע ע”י החברה ויוזן בהתאם לאחר מכן',
    'The SIM number on the card': 'מספר הסים שעל הכרטיס',
    'This number has 15 digits, and it appears in full on the physical card you received as described here:': 'מספר זה הוא בעל 15 ספרות, והוא מופיע במלואו על גבי הכרטיס הפיזי אותו קיבלתם כמתואר כאן:',
    'Type the phone number you want to activate': 'הקלידו את מספר הטלפון שאותו תרצו להפעיל',
    'ID number. entered when joining': 'מספר ת.ז. שהוזן בעת ההצטרפות',
    'Last 4 digits of the payment method': '4 ספרות אחרונות של אמצעי התשלום',
    'Enter last 7 digits of SIM card': 'הזינו 7 ספרות אחרונות של כרטיס סים',
    'SIM activation': 'הפעלת סים',
    'Your SIM card has been activated successfully!': 'כרטיס הסים שלך הופעל בהצלחה!',
    'Now insert the card into the device': 'כעת יש להכניס את הכרטיס לתוך המכשיר',
    'and restart the device': 'ולהפעיל את המכשיר מחדש',
    'Please note that the PING call center operates on Sunday-Thursday, between the hours of 08:00 and 21:00, and on Friday between the hours of 08:00 and 12:00.': 'לתשומת ליבך, מוקד PING פועל בימים א’-ה’, בין השעות 08:00-21:00, וביום ו’ בין השעות 08:00-12:00.',
    'Requests received outside business hours will be processed the next business day starting at 08:00 am': 'בקשות שיתקבלו מחוץ לשעות הפעילות יטופלו ביום העסקים הבא החל מ-08:00 בבוקר',
    'Attention - your number is about to be blocked!': ' שימו לב - מספרכם עומד להיות מנויד!',
    'Confirmation and activation': 'אישור והפעלה',
    'When there is no reception on your device, The device must be restarted': 'כאשר אין קליטה במכשירך,יש להפעיל את המכשיר מחדש',
    'One or more of the details you entered do not exist!': 'אחד או יותר מהפרטים שהזנתם אינם קיימים!',
    'In order to activate the SIM card,': 'על מנת להפעיל את כרטיס הסים,',
    'Please enter the correct details as they appeared in the purchase process': 'אנא הזינו את הפרטים הנכונים כפי שהופיעו בהליך הרכישה',
    'SIM card': 'כרטיס סים',
    'Yishuv': 'יישוב',
    'Street': 'רחוב',
    'No. Home': 'מס׳ בית',
    'settlement': 'יישוב',
    "Entering the subscriber's address": 'הזנת כתובת בעל המנוי',
    'Completion of an order': 'סיום הזמנה',
    'Total monthly subscription fees': "סך הכל דמי מנוי חודשיים",
    'Eternal surfing in the 5th generation country!': 'גלישה נצחית בארץ דור 5!',
    'minutes': 'דקות',
    'to complete the process': 'להשלמת התהליך',
    'Back to the previous ones': 'חזרה לקודמים',
    'show more': 'הצג עוד',
    'Before connecting to the service, you must make sure that your device supports eSIM technology. After completing the purchase, follow the instructions that will be sent to your email': 'לפני התחברות לשירות עליך לוודא כי מכשירך תומך בטכנולוגית eSIM. לאחר סיום הרכישה יש לעקוב אחרי ההוראות שישלחו לתיבת המייל שלך',
    'Note!': 'שים לב!',
    'This line is the only one on your list. You have to stay with at least one line in order': 'קו זה הוא היחיד ברשימתכם. יש להישאר עם קו אחד לפחות בכדי',
    'Continue the process, and deleting this line will take you to the beginning of the process': 'להמשיך את התהליך, ומחיקה של קו זה תיקח אתכם לתחילת התהליך',
    'A verification code will now be sent to @number@ via SMS.': 'כעת נשלח למספר- @number@ בהודעת SMS קוד אימות.',
    'Enter the 4 digits you received here': 'יש להזין כאן את 4 הספרות שקיבלת',
    'I approve of you': 'אני מאשר את',
    'The main points of the programs': 'עיקרי התוכניות',
    'Regulations and general conditions': 'התקנון ותנאים כלליים',
    'I approve all the lines that I have services': 'אני מאשר לכל הקווים שברשותי שירותים',
    'I agree to receive marketing messages from PING and its business partners by any means of mailing': 'אני מאשר קבלת מסרים שווקים של PING ושותפיה העסקיים בכל אמצעי דיוור',
    'If you joined using eSIM technology, after completing the purchase you must follow the instructions that will be sent to the email box. The service will be activated after downloading the profile and disconnecting the line.': 'במידה והצטרפת באמצעות טכנולוגיית eSIM, לאחר סיום הרכישה יש לעקוב אחרי ההוראות שישלחו לתיבת המייל. הפעלת השירות תתבצע לאחר הורדת הפרופיל ואיקטוב הקו.',
    'All subscriptions under this order will be associated with Expon 018, unless the customer has requested otherwise. Dialing to HOL must be done using the prefix 018 and the charges will appear on the mobile subscriber\'s invoice. As long as you don\'t dial abroad, you won\'t be charged for the 018 service.': 'כל המנויים במסגרת הזמנה זו ישויכו ל-אקספון 018, אלא אם הלקוח ביקש אחרת. חיוג לחול יש לבצע באמצעות קידומת 018 והחיובים יופיעו בחשבונית המנוי הסלולר. כל עוד לא תבצע חיוג לחול, לא תחויב עבור שירות 018.',
    'At least two characters must be entered. Letters, dashes and a dash (\') only': 'יש להזין לפחות שני תוים. אותיות, מקפים וגרש (\') בלבד',
    'A valid Israeli ID number must be entered, including a check digit': 'יש להזין מספר זהות ישראלי תקין כולל ספרת ביקורת',
    'A valid email address must be entered': 'יש להזין כתובת דוא"ל תקינה',
    'A valid Israeli number must be entered': 'יש להזין מספר ישראלי תקין',
    'Required field': 'שדה חובה',
    'Approval': 'אישור',
    'cancelation': 'ביטול',
    'Recommended package': 'חבילת מומלצת',
    'Add a line': 'הוספת קו',
    'Finishing Registration. Please Wait!': 'סיום ההרשמה. המתן בבקשה!',
    'Sunday': 'א’',
    'Monday': 'ב’',
    'Tuesday': ' ג’',
    'Wednesday': 'ד’',
    'Thursday': 'ה’',
    'Friday': 'ו’',
    'Saturday': 'ש’',
    'in the program': 'בתוכנית',
    'Details of the company': 'פרטי החברה',
    'The company address is the same as the shipping address': 'כתובת החברה זהה לכתובת למשלוח',
    'The shipping method': 'שיטת המשלוח',
    'No shipping required': 'אין צורך במשלוח',
    'how fun!': 'איזה כיף!',
    'The Number is not Available': 'יש להזין מספר טלפון תקין',
    'Continue Now an SMS with a verification code will be sent to the number': 'המשךכעת נשלח SMS עם קוד אימות למספר',
    'Continue good morning': 'המשךבוקר טוב',
    'My last invoice': 'החשבונית האחרונה שלי',
    'Download': 'הורדה',
    'viewing': 'צפייה',
    'Edit payment methods': 'עריכת אמצעי תשלום',
    'Recent messages': 'הודעות אחרונות',
    'Lorem Ipsum Dolor Sit Emmett, Consector Adipiscing Alit Consector Adipiscing Alit. Seth Almancom nisi non prophesied. Des Iacolis Volupta...': 'לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית קונסקטורר אדיפיסינג אלית. סת אלמנקום ניסי נון ניבאה. דס איאקוליס וולופטה...',
    'for all invoices': 'לכל החשבוניות',
    'eczema': 'גלשת',
    'left': 'נותרו',
    'To purchase additional browsing volume': 'לרכישת נפח גלישה נוסף',
    'Utilization of the surfing package in Israel': 'ניצול חבילת הגלישה בארץ',
    'Use of the surfing package abroad': 'שימוש בחבילת הגלישה בחו”ל',
    'Using a package of calls + SMS messages': 'ניצול חבילת שיחות + הודעות SMS',
    'you spoke': 'דיברת',
    'Call minutes abroad out of': 'דקות שיחה לחו”ל מתוך',
    'Messages from': 'הודעות מתוך ',
    'minutes from': 'דקות מתוך',
    'In a price of': 'במחיר של',
    'You joined the package on': 'הצטרפת לחבילה בתאריך',
    'A day to reset the package': 'יום לאיפוס החבילה',
    'remained': 'נשארו',
    'Package change': 'שינוי החבילה',
    'Termination of service': 'הפסקת השירות',
    'Select a subscription': 'בחר מנוי',
    'my packages': 'החבילות שלי',
    'quick actions': 'פעולות מהירות',
    'for all actions': 'לכל הפעולות',
    'update personal details': 'עדכון פרטים אישיים',
    'Managing my line': 'ניהול הקו שלי',
    'Change of mobile package': 'החלפת חבילת סלולר',
    'Browsing extension': 'הרחבת גלישה',
    'Call detail': 'פירוט שיחות',
    'Packages abroad': 'חבילות חו”ל',
    'su': 'א',
    'm': 'ב',
    'tu': 'ג',
    'w': 'ד',
    'th': 'ה',
    'f': 'ו',
    'sa': 'ש',
    'from': 'מתאריך',
    'to': 'עד תאריך',
    'Updating the range of dates for the activation of an overseas package': 'עדכון טווח תאריכי הפעלת חבילת חו”ל',
    'Please select a date range to activate the package': 'אנא בחר טווח תאריכים לצורך הפעלת החבילה',
    'updating': 'עדכון',
    'package abroad': 'חבילת חו”ל',
    'how fun!': 'איזה כיף!',
    'Once you are abroad, the package': 'ברגע שתהיו בחו”ל, החבילה',
    'that you purchased': 'שרכשתם',
    'start working': 'תתחיל לעבוד',
    'When the package is activated when you are abroad,': 'כשתופעל החבילה כשתהיו בחו”ל,',
    'You can view your browsing data,': 'תוכלו לצפות בנתוני הגלישה שלכם,',
    'and to purchase additional browsing volume': 'וכן לרכוש נפח גלישה נוסף',
    'The package activation date is on': 'תאריך הפעלת החבילה הוא בתאריך',
    'Ordering equipment with a courier': 'הזמנת ציוד עם שליח',
    'item': 'פריט',
    'SIM card for line number': 'כרטיס סים למספר קו',
    'Delivery method': 'שיטת משלוח',
    'main': 'ראשי',
    'my account': 'החשבון שלי',
    'Details of uses': 'פירוט השימושים',
    'Invoices': 'חשבוניות',
    'disconnection': 'התנתקות',
    'to arrange the payment': 'להסדרת התשלום',
    "under this account. Don't worry, the payment can be arranged quickly": 'תחת חשבון זה. אל דאגה, ניתן להסדיר את התשלום במהירות',
    'seems to exist': 'נראה כי קיים',
    'The quick actions rule': 'כלל הפעולות המהירות',
    'for all messages': 'לכל ההודעות',
    'cellular': 'סלולרי',
    'internet': 'אינטרנט',
    'international calls': 'שיחות בינלאומיות',
    'date': 'תאריך',
    'Type': 'סוג',
    'Invoice number': 'מספר חשבונית',
    'The amount to be charged includes VAT': 'הסכום לחיוב כולל מע״מ',
    'action': 'פעולה',
    'Details of charges': 'פירוט החיובים',
    'Download everything': 'הורד הכל',
    'the next': 'הבא',
    'Hi': 'היי',
    'full name': 'שם מלא',
    'ID.': 'ת.ז.',
    'Phone Number': 'מספר טלפון',
    'mail adress': 'כתובת מייל',
    'Subscriber address': 'כתובת המנוי',
    '012/Gold lines': 'קווי זהב/012',
    'Golan': 'גולן',
    'Barak/Netvizin' : 'ברק/נטוויזין',
    'Bezek international' : 'בזק בינלאומי',
    'Hello' : 'הלו',
    'Telezer' : 'טלזר',
    'I have read and confirm the details of the order, and the terms of engagement detailed in the regulations of the services I ordered and in the general conditions, in all my subscriptions.' :'קראתי ואני מאשר.ת את פרטי ההזמנה, ואת תנאי ההתקשרות המפורטים בתקנוני השירותים שהזמנתי ובתנאים הכלליים, בכל המנויים שלי.',
    'I approve inquiries and receiving marketing messages from Exphon and its business partners by phone and by any means of mailing. I understand that I can request removal at any time.' : 'אני מאשר.ת פניות וקבלת מסרים שיווקיים מאקספון ומשותפיה העסקיים בטלפון ובכל אמצעי דיוור. ידוע לי שאוכל לבקש הסרה בכל עת.',
    'Phone number must be exactly 10 characters' : 'מספר הטלפון חייב להיות באורך 10 תווים בדיוק',
    'I have read and confirm the details of the order, and the terms of engagement detailed in the regulations of the services I ordered' : 'קראתי ואני מאשר.ת את פרטי ההזמנה, ואת תנאי ההתקשרות המפורטים בתקנוני השירותים שהזמנתי',
    'and in the general conditions' : 'ובתנאים הכלליים',
    'in all my subscriptions' : 'ובתנאים הכלליים',
    'No Plan is selected' : 'לא נבחרה תוכנית',
    'No ZipCode for Address' : 'אין מיקוד עבור כתובת',
    'in all my subscriptions. Also, I agree to receive inquiries and marketing messages from Exphon and its business partners by phone and by any means of mailing. I understand that I can request removal at any time.' : 'בכל המנויים שלי. כמו כן, אני מאשר.ת קבלת פניות ומסרים שיווקיים מאקספון ומשותפיה העסקיים בטלפון ובכל אמצעי דיוור. ידוע לי שאוכל לבקש הסרה בכל עת.',
    'I have read and confirm the details of the order, and the terms of engagement detailed in the regulations of the services I ordered and the general conditions, in all my subscriptions. Also, I agree to receive inquiries and marketing messages from Exphon and its business partners by phone and by any means of mailing. I understand that I can request removal at any time.' : 'קראתי ומאשר את פרטי ההזמנה, ואת תנאי ההתקשרות המפורטים בתקנון השירותים שהזמנתי ובתנאים הכלליים, בכל המנויים שלי. כמו כן, אני מסכים לקבל פניות והודעות שיווקיות מאקספון ומשותפיה העסקיים בטלפון ובכל אמצעי דיוור. אני מבין שאני יכול לבקש הסרה בכל עת.',
    'Shipping fees, connection fees, SIM card cost, Israel Post (0 NIS) - up to 7 business days - one time' : 'דמי משלוח, דמי חיבור, עלות כרטיס SIM, דואר ישראל (0 ש"ח) - עד 7 ימי עסקים - פעם אחת',
    'Shipping fees, connection fees, SIM card cost, Home delivery (19.90 NIS) - up to 2 business days - one time' : 'דמי משלוח, דמי חיבור, עלות כרטיס SIM, מסירה לבית (19.90 ש"ח) - עד 2 ימי עסקים - פעם אחת',
    'Continue connecting': 'המשךהתחברות',
    'confirm me': 'אשרו אותי',
    'To connect to the personal area, you must type your ID card number': 'להתחברות לאזור האישי, יש להקליד את מספר תעודת הזהות שלך',
    'and then choosing a mobile code / email of your choice': 'ולאחר מכן בחירת קוד לנייד / דוא"ל לפי בחירתך',
    'Enter ID number...': 'הזן מספר זהות...',
    'Login to your account': 'כניסה לחשבונך',
    'Hi': 'היי',
    'Your ID number has been successfully identified': 'מספר הזהות שלך זוהה בהצלחה',
    'If this is indeed your number, click send, you can also enter another number': 'במידה וזהו אכן מספרך לחץ על שליחה, ניתן להזין גם מספר אחר',
    'Send code to mobile': 'שלחו קוד לנייד',
    'Email me the code': 'שלחו לי את הקוד לדוא”ל',
    'We will now send you a 4-digit verification code via SMS.': 'כעת נשלח אליך בהודעת SMS קוד אימות בן 4 ספרות.',
    'Enter the 4 digits you received here': 'יש להזין כאן את 4 הספרות שקיבלת',
    'Confirmation and login': 'אישור וכניסה',
    'Send code to email': 'שלחו קוד לדוא”ל',
    'This is a success': 'זוהית בהצלחה',
    'We will already transfer you to your personal area': 'כבר נעביר אותך לאזור האישי שלך',
    'Unable to enter': 'לא ניתן להיכנס',
    'Unfortunately, it is not possible to enter the personal area due to a malfunction': 'לצערנו לא ניתן להיכנס לאזור האישי עקב תקלה',
    'Try again': 'נסה שוב',
    'Send me the mobile code': 'שלחו לי את הקוד לנייד',
    'If this is indeed your email address, click send, You can also enter another email address': 'במידה וזוהי אכן כתובת הדוא”ל שלך לחץ על שליחה, ניתן להזין גם כתובת דוא”ל אחרת',
    'We will now email you a 4-digit verification code.': 'כעת נשלח אליך לדוא”ל קוד אימות בן 4 ספרות.',
    'must be at least 9 characters': 'חייב להיות לפחות 9 תווים',
    'must be at least 4 characters': 'חייב להיות לפחות 4 תווים',
    'Shipping fees, connection fees, SIM card cost, Home delivery (': 'דמי משלוח, דמי חיבור, עלות כרטיס SIM, משלוח עד הבית (',
    'NIS) - up to 2 business days - one time' : 'ש"ח) - עד 2 ימי עסקים - חד פעמי',
    'This package is Unlimited!': 'חבילה זו ללא הגבלה!',
    'Upload speed': 'מהירות העלאה',
    'Download speed': 'מהירות הורדה',
    'Until': 'עד',
    'Browsing speed': 'מהירות הגלישה',
    'Save': 'שמור',
    'Subscription number': 'מנוי מספר',
    'Edit subscription details': 'עריכת פרטי המנוי',
    'you sent': 'שלחת',
    'you spoke': 'דיברת',
    'Mobile subscription': 'מנוי לניוד'
}

